import {StyleSheet} from 'react-native';

import {chestnut} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  inline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  dotBefore: {
    fontSize: 20,
    lineHeight: 15,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  balance: {
    ...getFontFamily('normal'),
  },
  expiring: {
    color: chestnut,
  },
});
